import React from "react";
import "./styles.css";

interface ButtonIconProps {
  icon?: string;
  iconStyle?: React.CSSProperties;
}

export const ButtonIcon = ({ icon, iconStyle }: ButtonIconProps) => {
  if (!icon) return null;

  return <img src={icon} alt="" className="btn__icon" style={iconStyle} />;
};
